module.exports = __webpack_public_path__ + "img/site.31b179b1.svg";